var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("common.documents")))]),
      _c("app-aws-files-info", { attrs: { files: _vm.items } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }